import { render } from "./ModalContainer.vue?vue&type=template&id=31011cf8&ts=true"
import script from "./ModalContainer.vue?vue&type=script&lang=ts"
export * from "./ModalContainer.vue?vue&type=script&lang=ts"

import "./ModalContainer.vue?vue&type=style&index=0&id=31011cf8&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__